import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import ReadingPanePosition from 'owa-session-store/lib/store/schema/ReadingPanePosition';
import { GetStartedListPosition } from '../enums/GetStartedListPosition';

export function isGetStartedInSideBySideState(position: GetStartedListPosition): boolean {
    let readingPanePosition = getUserConfiguration().UserOptions.GlobalReadingPanePositionReact;

    return (
        position === GetStartedListPosition.ListView &&
        (readingPanePosition === ReadingPanePosition.Off ||
            readingPanePosition === ReadingPanePosition.Bottom)
    );
}
